/* Fades lazy images in once they have actually loaded. Only images that are
   still pending when this runs are touched, so anything already on screen
   (or without JS) stays fully visible. Paired with .ly-img-fade /
   .ly-img-visible in design-overrides.css. */
(function () {
  function reveal(img) {
    img.classList.add('ly-img-visible');
    img.addEventListener(
      'transitionend',
      function () {
        // Hand opacity back to the theme once the fade is done.
        img.classList.remove('ly-img-fade', 'ly-img-visible');
      },
      { once: true }
    );
  }

  function watch(scope) {
    scope.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      if (img.dataset.lyImgReveal) return;
      img.dataset.lyImgReveal = '';
      if (img.complete) return;

      img.classList.add('ly-img-fade');
      var done = function () {
        // Wait a frame so the opacity: 0 state is painted before transitioning.
        window.requestAnimationFrame(function () {
          reveal(img);
        });
      };
      img.addEventListener('load', done, { once: true });
      img.addEventListener('error', done, { once: true });
    });
  }

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  watch(document);

  document.addEventListener('shopify:section:load', function (event) {
    watch(event.target);
  });
})();
